import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=3e21a9de&scoped=true"
import script from "./uploadImg.vue?vue&type=script&lang=ts"
export * from "./uploadImg.vue?vue&type=script&lang=ts"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=3e21a9de&prod&lang=scss&scoped=true"
import style1 from "./uploadImg.vue?vue&type=style&index=1&id=3e21a9de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e21a9de",
  null
  
)

export default component.exports